import styles from './_dealer-dealer-group-editor-dialog.module.scss';
import { Window } from '@progress/kendo-react-dialogs';
import { WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Dealer, DealerDealerGroupInfo } from '../../../Models/Dealer';
import { GenericGrid } from '@amsanalytics/react-shared-library';
import { useState } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { InputChangeEvent, RadioButton, RadioButtonChangeEvent } from '@progress/kendo-react-inputs';
import { Field, Form, FormElement, FormRenderProps } from '@progress/kendo-react-form';
import { FormInput } from '@amsanalytics/react-shared-library';

export interface DealerDealerGruopEditorDialogProps {
  onCancel: () => void;
  onSubmit: (dealerDealerGroup: DealerDealerGroupInfo) => void;
  dealerGroupId: string;
  dealers: Dealer[]
}

export default function DealerDealerGruopEditorDialog(props: DealerDealerGruopEditorDialogProps) {
  const [selectedDealerId, setSelectedDealerId] = useState<string>();
  const [memberName, setMemberName] = useState<string>('');
  const [memberNumber, setMemberNumber] = useState<string>('');
  const [selectableDealers, setSelectableDealers] = useState<Dealer[]>(props.dealers.map(d => {return {...d, selected: false}})); 
  return (
    <div className={styles.dealerSelectorDialogContainer}>

      <Window width={600} height={600} title={'Select Dealer(s)'} modal={true}>

        <Form
          render={(formRenderProps: FormRenderProps) => (
            <FormElement style={{ width: '100%' }}>
              <fieldset className={"k-form-fieldset"}>
                <legend className={"k-form-legend"} style={{ marginBottom: '0px' }} >
                  <span style={{ fontWeight: '500' }}>{'Dealer Information'}</span>
                </legend>
              </fieldset>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1, width: '100%' }}>
                  <Field
                    style={{ width: '100%' }}
                    fieldWrapperStyle={{ width: '100%', marginLeft: '0px' }}
                    formFieldWrapperStyle={{ width: '100%', marginLeft: '0px' }}
                    name="memberName"
                    id="memberName"
                    type="text"
                    // useFloatingLabel={true}
                    label="Member Name *"
                    value={memberName}
                    onChange={(event: InputChangeEvent) => {
                      setMemberName(event.value);
                    }}
                    component={FormInput}
                    required={true}
                    validator={(value: any, valueGetter: (name: string) => any, fieldProps: { name: string }, required?: boolean) => {
                      return value?.length > 0 ? undefined : `Dealer Group Name is required`;;
                    }}
                  />
                  <Field
                    style={{ width: '100px' }}
                    fieldWrapperStyle={{ width: '100%', marginLeft: '0px' }}
                    formFieldWrapperStyle={{ width: '100%', marginLeft: '0px' }}
                    name="memberNumber"
                    id="memberNumber"
                    type="text"
                    // useFloatingLabel={true}
                    label="Member Number *"
                    value={memberNumber}
                    onChange={(event: InputChangeEvent) => {
                      setMemberNumber(event.value);
                    }}
                    component={FormInput}
                    required={true}
                    validator={(value: any, valueGetter: (name: string) => any, fieldProps: { name: string }, required?: boolean) => {
                      return value?.length > 0 ? undefined : `Member number is required`;;
                    }}
                  />

                </div>
              </div>
              <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column' }}>Select a Dealer</div>
              <GenericGrid<Dealer>
                disableEditing={true}
                disableAdding={true}
                itemName='Dealers'
                
                disableExcelExporting={true}
                disablePdfExporting={true}
                useIconButtons={true}
                disableGrouping={true}
                pageSizes={[200, 400, 1000]}
                pageSize={200}
                items={selectableDealers}
                selectedField={'selected'}                
                onItemSelected={(dealer: Dealer) => {
                  if (dealer) {
                    setSelectedDealerId(dealer.id);
                  }
                  setSelectableDealers(selectableDealers.map(d => {
                    if (d.id === dealer.id) {
                      return {...d, selected: true};
                    }
                    return {...d, selected: false};
                  }));
                }}

                sortDescriptors={[{ field: 'date', dir: 'desc' }]}
                columns={[                  
                  { field: "name", title: "Name" },
                ]}
              />

            </FormElement>
          )}
        />
        <WindowActionsBar layout={'stretched'}>
          <button
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
            onClick={() => { props.onCancel() }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
            disabled={!selectedDealerId || memberName === '' || memberNumber === ''}
            onClick={() => {
              if (selectedDealerId) {
                props.onSubmit({
                  dealerId: selectedDealerId,
                  dealerGroupId: props.dealerGroupId,
                  memberName: memberName,
                  memberNumber: memberNumber
                });
              }
            }}
          >
            {'Submit'}
          </button>
        </WindowActionsBar>
      </Window>
    </div>
  );
}
